import React from 'react'
import {Bar} from 'react-chartjs-2'
import PropTypes from 'prop-types';
import {objectWithoutProperties} from '../../../../utils/utils'

//================ Property Value Type =====================
const propsType={
    children:PropTypes.node,
};

//================ Default Property Value =====================
const defaultProps={
    
};

const barChart=(props)=>{

    const _props=props,
            children=_props.children,
            className=_props.className,
            attribute=objectWithoutProperties(props,'children');
        
    return (
        React.createElement(
            Bar,
            {className:className,...attribute},
            children
        )
    )
}

barChart.propTypes=propsType;
barChart.defaultProps=defaultProps;

export default barChart;